import React from 'react';
import { downloadBillingCycleUb04Pdf } from '../../services/api';
import { useBillingPdfDownload } from '../../hooks/useBillingPdfDownload';
import {
  BillingDownloadIconButton,
  BillingPdfMenuRow,
} from './BillingPdfMenuRow';

export interface BillingCycleUb04DownloadButtonProps {
  billingCycleId: string;
  /** When set, render as a full-width labeled menu row instead of an icon-only button. */
  label?: string;
}

export const BillingCycleUb04DownloadButton: React.FC<
  BillingCycleUb04DownloadButtonProps
> = ({ billingCycleId, label }) => {
  const { isDownloading, download } = useBillingPdfDownload(
    () =>
      downloadBillingCycleUb04Pdf({
        path: { billing_cycle_id: billingCycleId },
        responseType: 'blob',
      }),
    { failureTitle: 'Failed to generate claim', logLabel: 'UB-04 PDF' }
  );
  const handleClick = () => void download();

  if (label) {
    return (
      <BillingPdfMenuRow
        label={label}
        title='Open a printable UB-04 claim form (PDF)'
        isDownloading={isDownloading}
        onClick={handleClick}
      />
    );
  }

  return (
    <BillingDownloadIconButton
      label='Print UB-04 PDF'
      isDownloading={isDownloading}
      onClick={handleClick}
    />
  );
};
